/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2ExecuteRequest {
    getFixupPrototypeFunction() { return PolicyV2ExecuteRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2ExecuteRequest>): PolicyV2ExecuteRequest {
        let obj = Object.assign(new PolicyV2ExecuteRequest(), model);
        PolicyV2ExecuteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2ExecuteRequest>): PolicyV2ExecuteRequest {
        if (!model) return null;
        return PolicyV2ExecuteRequest.newInstance(<PolicyV2ExecuteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2ExecuteRequest) {
        if (!obj) return;

        models.PolicyV2ExecuteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2ExecuteRequest): boolean {
        Object.setPrototypeOf(obj, PolicyV2ExecuteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_account) {
            models.PolicyExecuteServiceAccount.fixupPrototype(this.service_account);
        }
        if (this.remediation_auto_trigger) {
            models.PolicyV2ExecutionRemediationAutoTrigger.fixupPrototype(this.remediation_auto_trigger);
        }
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
        if (this.args) {
            for (let val of this.args) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Execution parameter values, in the same NamedParameter format as the 'parameters' field in the Get Policy API response. Optionally set a parameter's 'schema.default_value' to override its value for this execution.
     */
    args: Array<models.NamedParameter>;

    /**
     * Cloud accounts to execute the policy against
     */
    service_account: models.PolicyExecuteServiceAccount;

    /**
     * Auto-trigger remediation post this policy execution
     */
    remediation_auto_trigger: models.PolicyV2ExecutionRemediationAutoTrigger;

    /**
     * Notification configuration for this execution
     */
    notifications: models.ConfigurationForNotifications;

}
